const BASE_URL = process.env.REACT_APP_API_URL || '';
const SECRET   = process.env.REACT_APP_API_SECRET || '';

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'x-api-secret': SECRET,
      ...(options.headers || {}),
    },
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `Request failed: ${res.status}`);
  }

  return res.json();
}

export const api = {
  getStatus:     ()           => request('/api/status'),
  getClients:    ()           => request('/api/clients'),
  getLogs:       (limit = 80) => request(`/api/logs?limit=${limit}`),
  getClientLogs: (id, limit = 30) => request(`/api/clients/${id}/logs?limit=${limit}`),
  addClient:     (data)       => request('/api/clients',      { method: 'POST',  body: JSON.stringify(data) }),
  updateClient:  (id, data)   => request(`/api/clients/${id}`,{ method: 'PATCH', body: JSON.stringify(data) }),
  syncClient:    (id)         => request(`/api/clients/${id}/sync`, { method: 'POST' }),
  getCallLogs:   (limit = 50) => request(`/api/voice/logs?limit=${limit}`),
  getDriftReport: (hours = 24) => request(`/api/drift-report?hours=${hours}`),
  getMirrorStatus: ()         => request('/api/mirror-status'),
  getCac:          (clientId)        => request(`/api/stats/cac?client_id=${clientId}`),
  saveCac:         (data)            => request('/api/stats/cac', { method: 'POST', body: JSON.stringify(data) }),
  deleteCac:       (clientId, month) => request(`/api/stats/cac?client_id=${clientId}&month=${month}`, { method: 'DELETE' }),
  triggerSnapshot: ()                => request('/api/stats/snapshot', { method: 'POST' }),
  backfillStats:   (clientId, months, offset = 0) => request(`/api/stats/backfill?client_id=${clientId}&months=${months}&offset=${offset}`, { method: 'POST' }),
  resyncAppts:     (clientId)        => request(`/api/clients/${clientId}/resync`, { method: 'POST' }),
  setupGhlFields:  (clientId)         => request(`/api/setup/ghl-fields?client_id=${clientId}`, { method: 'POST' }),
  searchProgress:  (clientId, q)     => request(`/api/progress-search?client_id=${clientId}&q=${encodeURIComponent(q || '')}`),
  getProgressReport: (contactId, clientId) => request(`/api/progress-report?contact_id=${contactId}&client_id=${clientId}`),
  getSurveyResults:     (contactId, clientId) => request(`/api/survey-results?contact_id=${contactId}&client_id=${clientId}`),
  backfillSurveyNames:  (clientId)           => request(`/api/survey-backfill-names?client_id=${clientId}`, { method: 'POST' }),
  archiveInactiveDryRun: (clientId, years)   => request(`/api/maintenance/archive-inactive?client_id=${clientId}&years=${years}&dry_run=1`, { method: 'POST' }),
  archiveInactive:       (clientId, years)   => request(`/api/maintenance/archive-inactive?client_id=${clientId}&years=${years}`, { method: 'POST' }),
  backfillPhones:        (clientId)          => request(`/api/maintenance/backfill-phones?client_id=${clientId}`, { method: 'POST' }),
};
